export default {
  props: ['isLoading'],
  name: 'brand',
  methods: {
    switchLocale (lang) {
      this.$i18n.locale = lang
    },
    whichOneIsActive (lang) {
      if (this.$i18n.locale === lang) {
        return true
      } else {
        return false
      }
    }

  },
  data: function () {
    return {
      activeClass: 'active'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/_globals/brand/brand.js